module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yyx-95d8ca5ecc1c66fa5fffe68c477f2b2c.png";